module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"CreateSuccess":"Le transporteur a bien été créée"}}')
  delete Component.options._Ctor
}
